module.exports = __webpack_public_path__ + "img/check-to-slot-duotone.fe73ec31.svg";